<template>
  <div >
    
  </div>
</template>
<script>
import { isAndroid } from '@/libs/utils'
import { mapState } from 'vuex';
import {
  closeOrderFrame,
  innerPurchaseFunctionSuc,
  registFunReportFunction,
  checkOrderState,
  registReturnGameFunction
} from '@/bridge/AppJsBridge';

export default {
  data() {
    return {
    }
  },
  async mounted() {
    await this.$store.dispatch('user/getCacheState');
    this._clientInit()
  },
  computed: {
    ...mapState({
      open: state => state.pay.open,
    })
  },
  components: {
  },
  methods: {
    _clientInit() {
      closeOrderFrame((data, cb) => {
        this.$store.commit('pay/CHANGE_STATE', {
          orderShow: false,
          orderIframeLink: ""
        })
      });
      innerPurchaseFunctionSuc((data, cb) => {
        this.$store.commit('pay/CHANGE_STATE', {
          yyb_info: JSON.parse(data)
        })
        this.$store.dispatch('pay/yybInnerPay')
        cb('yyb_Success');
      })
      registFunReportFunction((data, cb) => {
        // 将APP传过来没对应的数据做处理
        let orderInfo = JSON.parse(data);
        orderInfo.zfAmount = orderInfo.total_fee;
        this.$store.commit('pay/CHANGE_STATE', { order_info: orderInfo });
        console.log('抖音支付处理', orderInfo);
        // 调用pay/tiktokPlaceOrder下单
        this.$store.dispatch('pay/tiktokPlaceOrder', {});
      })
      checkOrderState((data, cb) => {
        this.$store.dispatch('pay/queryOrderResult');
      })
    },
    close() {
      registReturnGameFunction(null)
    },
    antiIndulgedClose() {
      if (this.open == 0 && !isAndroid()) {
        registReturnGameFunction(null);
      }
      this.$store.commit('pay/CHANGE_STATE', { antiIndulgedPayVisible: false });
      this.$store.commit('global/CHANGE_STATE', { preventBrush: false });
    },
    closeLargeCharge() {
      this.$store.commit('pay/CHANGE_STATE', { largeChargeVisible: false });
      this.$refs.chargeRef && this.$refs.chargeRef.resetRadio();
    },
  }
}
</script>

<style lang="scss" module>
.charge {
  width: 100%;
  height: 100%;
}
</style>